// extracted by mini-css-extract-plugin
module.exports = {"SiteTransferNotification":"SiteTransferNotification_SiteTransferNotification__QNXOK","modal":"SiteTransferNotification_modal__3yjBP"};